import { LocalRepository } from '../repositories'

/** 取得 Token */
export function getToken() {
  return LocalRepository.getToken();
}

/** 設定 Token */
export function setToken(token: string) {
  LocalRepository.setToken(token);
}

/** 移除 Token */
export function removeToken() {
  LocalRepository.removeToken();
}
